import { EDemandRequestStep } from '../../../constants';

export const getDemandRequestSteps = (phoneRequired: boolean, dealTypeRequired: boolean) => {
  switch (true) {
    case phoneRequired && dealTypeRequired:
      return [EDemandRequestStep.DEAL_TYPE, EDemandRequestStep.PHONE];
    case phoneRequired:
      return [EDemandRequestStep.PHONE];
    case dealTypeRequired:
      return [EDemandRequestStep.DEAL_TYPE];
    default:
      return [];
  }
};
